/**
 * `utils/intersection.js`
 * - IntersectionObserver を用いた監視処理
 *
 * 使用方法:
 * - import {manageNegativeClass} from "utils/intersection.js";
 * - manageNegativeClass.start();
 * - manageNegativeClass.stop();
 */

const manageNegativeClass = {
  observer: null,

  start(headerSelector = ".header", negativeSelector = ".negative") {
    if (this.observer) return; // すでに監視中なら何もしない

    const header = document.querySelector(headerSelector);
    if (!header) return;

    const negatives = document.querySelectorAll(negativeSelector);
    if (!negatives.length) return;

    const body = document.body;
    const headerHeight = header.offsetHeight; // ヘッダーの高さを取得
    const viewportHeight = window.innerHeight; // ビューポートの高さ

    this.observer = new IntersectionObserver(
      (entries) => {
        let isOverlapping = false;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isOverlapping = true;
          }
        });

        if (isOverlapping) {
          body.classList.add("is-negative");
        } else {
          body.classList.remove("is-negative");
        }
      },
      {
        root: null,
        rootMargin: `-${(headerHeight * .5) + 1}px 0px -${viewportHeight - (headerHeight * .5)}px 0px`,
        threshold: 0,
      }
    );

    negatives.forEach((element) => this.observer.observe(element));
  },

  stop() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};

export { manageNegativeClass };


const manageInversionClass = {
  observer: null,

  start(headerSelector = ".header", negativeSelector = "inversion") {
    if (this.observer) return; // すでに監視中なら何もしない

    const header = document.querySelector(headerSelector);
    if (!header) return;

    const negatives = document.querySelectorAll(negativeSelector);
    if (!negatives.length) return;

    const body = document.body;
    const headerHeight = header.offsetHeight; // ヘッダーの高さを取得
    const viewportHeight = window.innerHeight; // ビューポートの高さ

    this.observer = new IntersectionObserver(
      (entries) => {
        let isOverlapping = false;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isOverlapping = true;
          }
        });

        if (isOverlapping) {
          body.classList.add("is-inversion");
        } else {
          body.classList.remove("is-inversion");
        }
      },
      {
        root: null,
        rootMargin: `-${(headerHeight * .5) + 1}px 0px -${viewportHeight - (headerHeight * .5)}px 0px`,
        threshold: 0,
      }
    );

    negatives.forEach((element) => this.observer.observe(element));
  },

  stop() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};

export { manageInversionClass };
